import React, { Component } from "react";
import PropTypes from "prop-types";
import Config from "../../../../Config"; // Assuming you have a Config file with routes
import AppDialog from "../../../component/app_dialog/app_dialog.js";
import AppDialog1 from "../../../component/app_dialog/app_dialog1.js";

class BaseScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client: Config.context, // Replace with dynamic logic if necessary
      sessionExpired: false,
      timeLeft: 0, // Time left for session expiry (in seconds)
    };
    this.timer = null;
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      window.location.href = `/${this.state.client}/${Config.routes.generic.login}`;
      return;
    }

    this.initializeSessionTimer();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  initializeSessionTimer = () => {
    const sessionExpiry = sessionStorage.getItem("session_expiry");
    const currentTime = Date.now();

    if (sessionExpiry) {
      const timeLeft = Math.max(0, Math.floor((sessionExpiry - currentTime) / 1000));

      this.setState({ timeLeft }, () => {
        if (timeLeft === 0) {
          this.handleSessionExpiration();
        } else {
          this.startCountdown();
        }
      });
    }
  };

  startCountdown = () => {
    this.timer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timeLeft <= 1) {
          clearInterval(this.timer);
          this.handleSessionExpiration();
          return { timeLeft: 0 };
        }
        return { timeLeft: prevState.timeLeft - 1 };
      });
    }, 1000);
  };

  handleSessionExpiration = () => {    
    this.setState({ sessionExpired: true });
  };

  formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  render() {
    const token = sessionStorage.getItem("token");
    if (!token) return null; // Prevent rendering if user is being redirected

    const isSessionExpired = this.state.sessionExpired || this.props.errorCode === "1111";

    return (
      <>
        {isSessionExpired && (
          <AppDialog
            isOpen={true}
            title={""}
            description={"User Session Expired / <i>Sesi pengguna telah tamat</i>"}
            buttonLabel={"Ok"}
            onClick={() => {
              sessionStorage.clear();
              localStorage.clear();
              window.location.href = `/${this.state.client}/${Config.routes.generic.login}`;
            }}
          />
        )}

        {this.props.errorCode && this.props.errorCode !== "1111" && this.props.screen !== "OTP" && (
          <AppDialog1
            isOpen={true}
            title={""}
            description={this.props.errorCode}
            buttonLabel={"Ok"}
            onClick={() => {
              sessionStorage.clear();
              localStorage.clear();
              window.location.href = `/${this.state.client}/${Config.routes.generic.login}`;
            }}
          />
        )}

        {this.props.children}
      </>
    );
  }
}

BaseScreen.propTypes = {
  children: PropTypes.node.isRequired,
  errorCode: PropTypes.string,
  screen: PropTypes.string,
};

export default BaseScreen;
